

<mat-toolbar>
    <span>{{itemDetails.Name}}</span>
    <span class="fill-remaining-space"></span>
    <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
  </mat-toolbar>

  <form  [formGroup] ="addItemForm" (ngSubmit)="addStockButtonClick()"  class="form-horizontal">
  <mat-grid-list cols="1" rowHeight="200px">
    <mat-grid-tile>
    <div class="controles-container">  
      <input type="hidden"  readonly formControlName="id">       
    <div class="row">
    <div class="col-md-12">
        <table class="table table-clear">
          <thead>
            <tr>
              <th style="width: 30%"  scope="col" style="text-align: center">In Stock</th> 
              <th style="width: 30%"  scope="col" style="text-align: center">Add Qty</th>            
              <th style="width: 40%"  scope="col" style="text-align: center">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>             
              <td><input type="number" style="text-align: right" readonly formControlName="qtyInStock"   class="form-control form-control-sm field-bg-color"></td>                  
              <td>
                <input type="number"  style="text-align: right" formControlName="qty"  [class.is-invalid]="formErrors.qty" class="form-control form-control-sm" (blur)="logValidationErrors()"></td>                           
              <td><input type="number" style="text-align: right"   formControlName="amount"    class="form-control form-control-sm field-bg-color"></td>                                                 
           </tr>  
          </tbody>
        </table>
    </div>
  </div>


      <div class="button-row justify-content-center mt-1">
        <button type="submit" [disabled]="!addItemForm.valid"  mat-raised-button color="primary" class="mr-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Add Stock
        </button>         
      </div>

      </div>
    </mat-grid-tile>
  </mat-grid-list>
  <!-- Form Values : {{ addItemForm.value | json }}  -->
</form>


         

